import React from 'react'
import styled from 'styled-components'
import BaseLayout from './BaseLayout'

const Main = styled.main`
  display: grid;

  @media screen and (min-width: 640px) {
    grid-template-rows: calc(50% + 16.5rem) calc(50% - 16.5rem);
    justify-items: center;
    min-height: 100vh;
  }
`

const MainLayout = ({ children }) => (
  <BaseLayout>
    <Main>{children}</Main>
  </BaseLayout>
)

export default MainLayout
